
import {
  FETCH_COMPANIES,
  ADD_COMPANY,
  DELETE_COMPANY
} from "../actions/types";
import {sortArrayByObjectField} from '../helpers/sort';

function sortByCompanyName(companies) {
  // return companies.sort(name => name);
  return sortArrayByObjectField(companies,"name");
}

export default function rootReducer(state = [], action) {

  switch (action.type) {

    case FETCH_COMPANIES:
      if(!action.companies)return state;
      return sortByCompanyName([...action.companies]);
    case ADD_COMPANY:
      if(!action.company)return state;
      return sortByCompanyName([...state, action.company]);
    case DELETE_COMPANY:
      if(!action.deleted)return state;
      return sortByCompanyName([...state.filter(co => co.id !== action.deleted.id)]);
    default:
      return state;
  }
}
